import { Center, Image, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./VideoHero.module.css";
import logo from "../../media/lmuTV.png";

// Trailer + thumbnail not yet produced for LMU TV. Render a maroon placeholder
// card with the logo so the home page does not display ACC TV stock art.
export function VideoHero() {
  const { t } = useTranslation();
  return (
    <div className={classes.videoContainer}>
      <Center>
        <Stack align="center" gap="md" py="xl" px="md" className={classes.placeholder}>
          <Image src={logo} alt="LMU TV" w={120} h={120} radius="md" />
          <Text size="xl" fw={700}>LMU TV</Text>
          <Text c="dimmed" ta="center">
            {t("title.advertisement-text")}
          </Text>
        </Stack>
      </Center>
    </div>
  );
}
